import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["exportButton", "warehouseSelect"]

  connect() {
  }

  warehouseChanged() {
    this.updateExportButton()
  }

  updateExportButton() {
    const warehouseId = this.warehouseSelectTarget.value
    
    if (warehouseId && warehouseId !== '') {
      this.exportButtonTarget.classList.remove('d-none')
      // Set the URL with .xlsx format
      this.exportButtonTarget.href = `/reports/warehouses/export_products.xlsx?warehouse_id=${warehouseId}`
      
      // Update confirmation message
      const selectedOption = this.warehouseSelectTarget.selectedOptions[0]
      if (selectedOption && selectedOption.text !== 'All Warehouses') {
        this.exportButtonTarget.dataset.confirm = `Export products for ${selectedOption.text}?`
      }
    } else {
      this.exportButtonTarget.classList.add('d-none')
    }
  }
}
